<template>
  <div>
    <b-form
      ref="form"
      :style="{ height: trHeight }"
      class="repeater-form mt-0"
      @submit.prevent="repeateAgain"
    >
      <!-- Row Loop -->
      <b-row
        v-for="(address, index) in addresses"
        :key="index"
        ref="row"
        class="mb-1"
      >
        <b-col xl="3" lg="3" md="4" sm="6">
          <b-form-group
            :label="$t('address.type')"
            :label-for="`admission-address-type${index}`"
          >
            <my-v-select
              :key="addresses[index].type"
              :id="`admission-address-type${index}`"
              v-if="types"
              :translate="false"
              v-model="addresses[index].type"
              :concat-label="['text']"
              :reduce-field="['value']"
              :options="types.length ? types : []"
              :multiple="false"
              :searchable="true"
              :filterable="true"
            />
          </b-form-group>
        </b-col>
        <!-- Item Country -->
        <b-col xl="2" lg="3" md="4" sm="6">
          <b-form-group
            :label="`${$t('address.country')}`"
            label-for="admission-address-country"
            :invalid-feedback="
              invalidCountry(index)
                ? $t(`validation.${invalidCountry(index)}`, {
                    field: $t('address.country'),
                  })
                : ''
            "
            :state="v.addresses.$each.$iter[index].countryId.$dirty ? ((!v.addresses.$each.$iter[index].countryId.$invalid === false) ? false : null) : null"
            :class="{
              'required-group':
                !v.addresses.$each.$iter[index].countryId.required,
            }"
          >
            <my-v-select
              :key="addresses[index].countryId"
              id="admission-address-country"
              v-if="countries"
              :translate="false"
              v-model="addresses[index].countryId"
              :concat-label="['title.fa', 'phoneCode']"
              :options="countries.length ? countries : []"
              :multiple="false"
              :searchable="true"
              :filterable="true"
            />
          </b-form-group>
        </b-col>
        <!-- Item Province -->
        <!--        <b-col xl="3" lg="3" md="4" sm="6">-->
        <!--          <b-form-group-->
        <!--            :label="`${$t('address.province')}`"-->
        <!--            label-for="admission-address-province"-->
        <!--            :invalid-feedback="-->
        <!--              invalidProvince(index)-->
        <!--                ? $t(`validation.${invalidProvince(index)}`, {-->
        <!--                    field: $t('address.province'),-->
        <!--                  })-->
        <!--                : ''-->
        <!--            "-->
        <!--            :state="-->
        <!--                v.addresses.$each.$iter[index].provinceId.$dirty-->
        <!--                  ? !v.addresses.$each.$iter[index].provinceId.$invalid-->
        <!--                  : null-->
        <!--              "-->
        <!--            :class="{'required-group' : !v.addresses.$each.$iter[index].provinceId.required}"-->
        <!--          >-->
        <!--            <my-v-select-->
        <!--                :key="addresses[index].provinceId"-->
        <!--                id="admission-address-province"-->
        <!--                v-if="provinces"-->
        <!--                :translate="false"-->
        <!--                v-model="addresses[index].provinceId"-->
        <!--                :concat-label="['title']"-->
        <!--                :options="provinces.length ? provinces : []"-->
        <!--                :multiple="false"-->
        <!--                :searchable="true"-->
        <!--                :filterable="true"-->
        <!--                @input="getCities(index)"-->
        <!--            />-->
        <!--          </b-form-group>-->
        <!--        </b-col>-->
        <!-- Item City -->
        <b-col xl="2" lg="3" md="4" sm="6">
          <b-form-group
            :label="`${$t('address.city')}`"
            label-for="admission-address-city"
            :invalid-feedback="
              invalidCity(index)
                ? $t(`validation.${invalidCity(index)}`, {
                    field: $t('address.city'),
                  })
                : ''
            "
            :state="v.addresses.$each.$iter[index].cityId.$dirty ? ((!v.addresses.$each.$iter[index].cityId.$invalid === false) ? false : null) : null"
            :class="{
              'required-group': !v.addresses.$each.$iter[index].cityId.required,
            }"
          >
            <my-v-select
              :key="addresses[index].cityId"
              id="admission-address-city"
              :disabled="!addresses[index].countryId"
              :translate="false"
              v-model="addresses[index].cityId"
              :concat-label="['title.fa','phoneCode']"
              :options="(addressCities[index] && addressCities[index].length) ? addressCities[index] : []"
              :multiple="false"
              :searchable="true"
              :filterable="true"
              @search="fetchCities($event,index)"
            />
          </b-form-group>
        </b-col>
<!--        <b-col v-else xl="2" lg="3" md="4" sm="6">-->
<!--          <b-form-group-->
<!--            :label="`${$t('address.city')}`"-->
<!--            label-for="admission-address-city"-->
<!--            :invalid-feedback="-->
<!--              invalidCityNameForForeign(index)-->
<!--                ? $t(`validation.${invalidCityNameForForeign(index)}`, {-->
<!--                    field: $t('address.city'),-->
<!--                  })-->
<!--                : ''-->
<!--            "-->
<!--            :state="-->
<!--              v.addresses.$each.$iter[index].cityNameForForeign.$dirty-->
<!--                ? !v.addresses.$each.$iter[index].cityNameForForeign.$invalid-->
<!--                : null-->
<!--            "-->
<!--            :class="{-->
<!--              'required-group':-->
<!--                !v.addresses.$each.$iter[index].cityNameForForeign.required,-->
<!--            }"-->
<!--          >-->
<!--            <b-form-input-->
<!--              id="user-birthCity-foreigner"-->
<!--              v-model="addresses[index].cityNameForForeign"-->
<!--              :state="-->
<!--              v.addresses.$each.$iter[index].cityNameForForeign.$dirty-->
<!--                ? !v.addresses.$each.$iter[index].cityNameForForeign.$invalid-->
<!--                : null-->
<!--            "-->
<!--            />-->
<!--            &lt;!&ndash;            <my-v-select&ndash;&gt;-->
<!--            &lt;!&ndash;                :key="addresses[index].cityId"&ndash;&gt;-->
<!--            &lt;!&ndash;                id="admission-address-city-foreigner"&ndash;&gt;-->
<!--            &lt;!&ndash;                :disabled="!cities.length"&ndash;&gt;-->
<!--            &lt;!&ndash;                v-if="cities"&ndash;&gt;-->
<!--            &lt;!&ndash;                :translate="false"&ndash;&gt;-->
<!--            &lt;!&ndash;                v-model="addresses[index].cityId"&ndash;&gt;-->
<!--            &lt;!&ndash;                :concat-label="['title']"&ndash;&gt;-->
<!--            &lt;!&ndash;                :options="cities.length ? cities : []"&ndash;&gt;-->
<!--            &lt;!&ndash;                :multiple="false"&ndash;&gt;-->
<!--            &lt;!&ndash;                :searchable="true"&ndash;&gt;-->
<!--            &lt;!&ndash;                :filterable="true"&ndash;&gt;-->
<!--            &lt;!&ndash;            />&ndash;&gt;-->
<!--          </b-form-group>-->
<!--        </b-col>-->
        <!-- Item PostalCode -->
        <!--        <b-col xl="2" lg="3" md="4" sm="12">-->
        <!--          <b-form-group-->
        <!--            :invalid-feedback="-->
        <!--              invalidPostalCode(index)-->
        <!--                ? $t(`validation.${invalidPostalCode(index)}`, {-->
        <!--                    field: $t('address.postalCode'),-->
        <!--                  })-->
        <!--                : ''-->
        <!--            "-->
        <!--            :label="$t('address.postalCode')"-->
        <!--            :state="-->
        <!--              addresses[index].postalCode.length &&-->
        <!--              v.addresses.$each.$iter[index].postalCode.$dirty-->
        <!--                ? !v.addresses.$each.$iter[index].postalCode.$invalid-->
        <!--                : null-->
        <!--            "-->
        <!--            :label-for="`admission-address-postalCode${index}`"-->
        <!--          >-->
        <!--            <b-form-input-->
        <!--              @keypress="preventPostalCodeType($event, index)"-->
        <!--              type="number"-->
        <!--              aria-describedby="admission-address-postalCode"-->
        <!--              v-model="addresses[index].postalCode"-->
        <!--              dir="ltr"-->
        <!--              :state="-->
        <!--                addresses[index].postalCode.length &&-->
        <!--                v.addresses.$each.$iter[index].$dirty-->
        <!--                  ? !v.addresses.$each.$iter[index].postalCode.$invalid-->
        <!--                  : null-->
        <!--              "-->
        <!--              :id="`admission-address-postalCode${index}`"-->
        <!--            />-->
        <!--          </b-form-group>-->
        <!--        </b-col>-->

        <!-- Item Address -->
        <b-col xl="10" lg="7" md="10" sm="12">
          <b-form-group
            :label="$t('address.address')"
            :label-for="`admission-address-address${index}`"
          >
            <b-form-input
                aria-describedby="admission-address-address"
              v-model="addresses[index].address"
              :id="`admission-address-address${index}`"
            />
          </b-form-group>
        </b-col>
        <!-- Remove and Add Button -->
        <b-col xl="2" md="2">
          <div class="action-buttons has-margin md">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="white"
              @click="removeItem(index)"
            >
              <b-icon icon="x-circle" variant="danger" scale="2"></b-icon>
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="white"
              @click="repeateAgain"
            >
              <b-icon icon="plus-circle" variant="success" scale="2"></b-icon>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import BCardCode from "@core/components/b-card-code";
import postalCodeValidation from "@/mixins/validations/postalCode";
import { required } from "vuelidate/lib/validators";
import { heightTransition } from "@/mixins/ui/transition";
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BFormSelect,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { mapGetters } from "vuex";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
// import { codeBasic } from "./code";

export default {
  components: {
    MyVSelect,
    BCardCode,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BFormSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      nextTodoId: 2,
    };
  },
  mixins: [postalCodeValidation, heightTransition],
  computed: {
    ...mapGetters({
      countries: "location/countries",
      types: "user/addressTypes",
    }),
    mobiles: {
      set(mobiles) {
        this.$store.commit("user/SET_MOBILE", mobiles);
      },
      get() {
        return this.$store.getters["user/mobiles"];
      },
    },
    country: {
      set(country) {
        this.$store.commit("user/SET_COUNTRY", country);
      },
      get() {
        return this.$store.getters["user/country"];
      },
    },
    addressCities: {
      set(addressCities) {
        this.$store.commit("user/SET_ADDRESS_CITIES", addressCities);
      },
      get() {
        return this.$store.getters["user/addressCities"];
      },
    },
    city: {
      set(city) {
        this.$store.commit("user/SET_CITY", city);
      },
      get() {
        return this.$store.getters["user/city"];
      },
    },
    // province: {
    //   set(province) {
    //     this.$store.commit("user/SET_PROVINCE", province);
    //   },
    //   get() {
    //     return this.$store.getters["user/province"];
    //   },
    // },
    addresses: {
      set(addresses) {
        this.$store.commit("user/SET_ADDRESSES", addresses);
      },
      get() {
        return this.$store.getters["user/addresses"];
      },
    },
  },
  mounted() {
    this.initTrHeight();
    this.addresses.forEach((address, index) => {
      this.$set(address, "type", "home");
    });
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  props: ["v"],
  methods: {
    preventPostalCodeType(value, index) {
      if (!this.v.addresses.$each.$iter[index].postalCode.maxLength) {
        value.preventDefault();
        return;
      }
    },
    fetchCities(search, index){
      if(search.length) {
        this.$store.dispatch("location/cities", {
          countryId: this.addresses[index].countryId,
          title: search
        }).then((res)=>{
          this.$set(this.addressCities, index, res);
        })
      }
    },
    invalidAddress(index) {
      var error = "";
      if (!this.v.addresses.$each.$iter[index].address.$dirty) return error;
      if (!this.v.addresses.$each.$iter[index].address.required) {
        error = "required";
        return error;
      }
      return error;
    },
    invalidCountry(index) {
      var error = "";
      if (!this.v.addresses.$each.$iter[index].countryId.$dirty) return error;
      if (!this.v.addresses.$each.$iter[index].countryId.required) {
        error = "required";
        return error;
      }
      return error;
    },
    // invalidProvince(index) {
    //   var error = "";
    //   if (!this.v.addresses.$each.$iter[index].provinceId.$dirty) return error;
    //   if (!this.v.addresses.$each.$iter[index].provinceId.required) {
    //     error = "required";
    //     return error;
    //   }
    //   return error;
    // },
    invalidCity(index) {
      var error = "";
      if (!this.v.addresses.$each.$iter[index].cityId.$dirty) return error;
      if (!this.v.addresses.$each.$iter[index].cityId.required) {
        error = "required";
        return error;
      }
      return error;
    },
    // invalidCityNameForForeign(index) {
    //   var error = "";
    //   if (!this.v.addresses.$each.$iter[index].cityNameForForeign.$dirty)
    //     return error;
    //   if (
    //     !this.v.addresses.$each.$iter[index].cityNameForForeign.required
    //   ) {
    //     error = "required";
    //     return error;
    //   }
    //   return error;
    // },
    // getProvinces(index) {
    //   this.$store.dispatch(
    //       "provinces/searchProvince",
    //       {countryId: this.addresses[index].countryId, status: 'active'}
    //   );
    // },

    // getCities(index) {
    //   this.$store.dispatch("location/cities", {
    //     countryId: this.addresses[index].countryId,
    //   }).then((res) =>{
    //     this.$set(this.addressCities, index, res)
    //     // this.addressCities[index] = res
    //   });
    // },
    repeateAgain() {
      this.addresses.push({
        cityId: "",
        address: "",
        postalCode: "",
        type: "",
        countryId: "",
      });
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      if (index !== 0) {
        this.addresses.splice(index, 1);
        this.trTrimHeight(this.$refs.row[0].offsetHeight);
      }
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>
